import { render, staticRenderFns } from "./Disbursements.vue?vue&type=template&id=4ceb8068"
import script from "./Disbursements.vue?vue&type=script&lang=js"
export * from "./Disbursements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports